import { Component, OnInit, Input } from '@angular/core';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-postal-address',
  templateUrl: './postal-address.component.html',
  styleUrls: ['./postal-address.component.sass']
})
export class PostalAddressComponent implements OnInit {
 
  @Input() AddressDet:string;
  @Input() AddressDet2:string;
  @Input() City:string;
  @Input() Country:string;
  @Input() State:string;
  @Input() ZipCode:string;
  public showErrorDir1:boolean;
  public showErrorCiudad:boolean;
  public showErrorCodPost:boolean;
  public showErrorCodPostLength;
  public submitted2;
  public selectBan:string;
  constructor(private services: Service,private global:GlobalService,private loadingScreenService :LoadingScreenService) { }
  ngOnInit() {
    if(this.global.sessionReview()==true){
      this.selectBan=atob(sessionStorage.getItem("selectBan"));
    }
  }
  validarDir() {
    var sw = true;
    if (this.AddressDet === '') {
      this.showErrorDir1 = true;
        sw = false;
    }
    else {
      this.showErrorDir1 = false;
    }
    if (this.City === '') {
      this.showErrorCiudad = true;
        sw = false;
    }
    else {
      this.showErrorCiudad = false;
    }
    if (this.ZipCode === '') {
      this.showErrorCodPost = true;
        sw = false;
    }
    else {
      this.showErrorCodPost = false;
        if (this.ZipCode.length < 5) {
          this.showErrorCodPostLength = true;
            sw = false;
        }
        else {
          this.showErrorCodPostLength = false;
        }
    }
    return sw;
  }

  updateDir() {
    this.global.validateSession();
    this.submitted2=true;
    if (this.validarDir()) {
        var idCodPost = this.ZipCode;
        if (this.ZipCode.length === 5) {
            idCodPost = idCodPost + '-0000';
        }
        else if (this.ZipCode.length === 6) {
            idCodPost = idCodPost + '0000';
        }
        else if (this.ZipCode.length === 7) {
            idCodPost = idCodPost + '000';
        }
        else if (this.ZipCode.length === 8) {
            idCodPost = idCodPost + '00';
        }
        else if (this.ZipCode.length === 9) {
            idCodPost = idCodPost + '0';
        }
        this.ZipCode = idCodPost;
        this.loadingScreenService.startLoading();
        this.services.updatePersonalDir(sessionStorage.getItem("token"),this.selectBan,this.AddressDet,this.AddressDet2,this.City,this.ZipCode).subscribe(data =>{
          this.loadingScreenService.stopLoading();
          if(data.HasError ==true){
            this.global.notif(data.ErrorDesc);
          }
          else{
            this.global.notif(data.ErrorDesc);
          }
        });
    }
    else {
        if (this.submitted2 && this.showErrorDir1) {
            this.global.notif("Debe colocar la dirección 1");
        }
        if (this.submitted2 && this.showErrorCodPost) {
            this.global.notif("Debe colocar el código postal");
        }
        if (this.submitted2 && this.showErrorCiudad) {
            this.global.notif("Debe colocar la ciudad");
        }
        if (this.submitted2 && this.showErrorCodPostLength) {
            this.global.notif("El código postal debe ser mayor a 4 caracteres.");
        }
        return;
    }
  }
}